import { render } from "./TestimonialComponent.vue?vue&type=template&id=776701f6"
import script from "./TestimonialComponent.vue?vue&type=script&lang=js"
export * from "./TestimonialComponent.vue?vue&type=script&lang=js"

import "./TestimonialComponent.vue?vue&type=style&index=0&id=776701f6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__